import React from 'react'
import { connect } from 'react-redux';
// import ReactTags from 'react-tag-input'
import { WithContext as ReactTags } from 'react-tag-input';
import { updateSearchParameters, updateSearchResults } from '../../Redux/SearchEngine/actions';


const KeyCodes = {
    comma: 188,
    enter: [10, 13],
  };
  
const delimiters = [...KeyCodes.enter, KeyCodes.comma];

const SearchFilter = (props) => {
    
    const [tags, setTags] = React.useState([])

    const suggestions = [
        { id: 'USA', text: 'USA' },
        { id: 'Germany', text: 'Germany' },
        { id: 'Austria', text: 'Austria' },
        { id: 'Costa Rica', text: 'Costa Rica' },
        { id: 'Sri Lanka', text: 'Sri Lanka' },
        { id: 'Thailand', text: 'Thailand' }
     ]

     const handleDelete = (i) => {
        let _tags = tags;
        _tags.slice(i, 1)
        setTags(_tags)
     }

     const handleAddition = (tag) => {
        setTags([ ...tags, tag ])
     }
     const handleDrag = (i) => {
        console.log(i);
     }

    return (
        <div>
            {props?.searchParameters?.map && (
                    <p>
                    <b>Location: </b> <br/>{props?.searchParameters?.map?.address}
                    <a class="underlink mx-2">[{props?.searchParameters?.range}Km range]</a>
                </p>
            )}
        </div>
    )
}


const mapStateToProps = ({ searchParameters }) => {
	return { searchParameters };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateSearchResults: (e) => dispatch(updateSearchResults(e)),
		updateSearchParameters: (e) => dispatch(updateSearchParameters(e))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilter);

